import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import {
  AvailableOperationsByPropertyType,
  type DistanceFromVal,
  GetOperationLabel,
  type PropertyFilterInfo,
} from 'donor-elf-web/lib/filter-utils-new';
import type { SelectOption } from 'donor-elf-web/lib/form-component-utils';

interface ComponentArgs {
  selectedPropertyFilterInfo: PropertyFilterInfo;
  changeset: any;
  showValidationErrors: boolean;
  onEnter: () => void; // called when the user hits the enter key on the location text field
}

export default class FilterEditDistanceFromComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);

    const { changeset } = this.args;
    const distanceFromVal = changeset.get('val') as DistanceFromVal | undefined;

    if (typeof distanceFromVal === 'object') {
      setTimeout(() => {
        changeset.set('distanceFromDistance', distanceFromVal.distance);
        changeset.set('distanceFromUnits', distanceFromVal.units ?? 'miles');
        changeset.set('distanceFromLocation', distanceFromVal.location);
      });
    }
  }

  distanceOptions: SelectOption[] = [
    { val: 25, label: '25 miles' },
    { val: 50, label: '50 miles' },
    { val: 75, label: '75 miles' },
    { val: 100, label: '100 miles' },
    { val: 200, label: '200 miles' },
    { val: 300, label: '300 miles' },
    { val: 400, label: '400 miles' },
    { val: 500, label: '500 miles' },
  ];

  distanceFromLocationEl?: any;

  // expects only 1 operation for distanceFrom for the time being
  get operationLabel() {
    const operation =
      this.args.selectedPropertyFilterInfo.availableOperations?.[0] ||
      AvailableOperationsByPropertyType.distanceFrom[0];
    return GetOperationLabel(operation, { propertyType: 'distanceFrom' });
  }

  get distanceFromDistanceIsEmpty() {
    return isEmpty(this.args.changeset.get('distanceFromDistance'));
  }

  handleDistanceFromDistanceChanged = () => {
    if (
      this.distanceFromLocationEl &&
      isEmpty(this.distanceFromLocationEl.text)
    ) {
      this.distanceFromLocationEl.focus();
    }
  };

  // record this element so it can be focused on after the user selects the distance
  handleDistanceFromLocationDidInsert = (el: any) => {
    this.distanceFromLocationEl = el;
  };

  willDestroy() {
    if (this.distanceFromLocationEl) {
      this.distanceFromLocationEl = undefined;
    }
  }
}
